import styled, { keyframes } from 'styled-components';

import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';

// Deliberately off-palette ROYGBIV hues (yellow deepened for contrast on
// light backgrounds).
const roygbivCycle = keyframes`
  0%, 100% { color: #E02020; }
  14% { color: #F77B00; }
  29% { color: #E6B800; }
  43% { color: #1DA943; }
  57% { color: #2D6BEB; }
  71% { color: #4B0082; }
  86% { color: #8E30D6; }
`;

/**
 * AutoAwesome ("sparkle") icon that cycles through rainbow colors, used to
 * mark AI-powered actions. Holds a static color when the user prefers
 * reduced motion. Accepts the same props as an MUI icon.
 */
const SparkleIcon = styled(AutoAwesomeIcon)`
  animation: ${roygbivCycle} 6s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default SparkleIcon;
